<template>
  <div class="bots-num-bottom borde-dashed">
    <v-layout row wrap>
      <v-flex xs12 class="bnb-contain aligner">
        <div id="bnb-contain" tabindex="0" class="textos">
          <slot v-if="index + 1 === contenidoActual" v-for="(item, index) in numeroBotones" :name="'cont'+index"></slot>
          <button v-if="!finContenidos && (contenidoActual > 0)" @click="backMenu()" aria-label="Volver a la lista anterior"></button>
        </div>
      </v-flex>
      <v-flex xs12 text-xs-center>
        <div class="bnb-buttons">
          <ul class="unstyled-list">
            <li v-for="(item, index) in numeroBotones">
              <button :id="'bnb-bots'+index" @click="showCont(index)" :aria-label="'Botón ' + (index+1) + ' ' + (botones[index].visto?'visto':'no visto')" class="hvr-grow" :class="botsColorsClass(index)">
                {{index+1}}
              </button>
            </li>
          </ul>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: {
    numeroBotones: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      contenidoActual: 1,
      finContenidos: false,
      currentBot: 1
    };
  },
  methods: {
    showCont(event) {
      this.contenidoActual = event + 1;
      this.botones[event].visto = true;
      document.getElementById("bnb-contain").focus();
      var showNext = this.botones.every(elem => {
        return elem.visto === true;
      });
      if (showNext) {
        this.$store.commit("nextShow", true);
      }
      this.finContenidos = showNext;
    },
    backMenu() {
      document.getElementById("bnb-bots" + this.contenidoActual).focus();
    },
    botsColorsClass(event) {
      var claseUno = event + 1 === this.contenidoActual ? "active" : "";
      var claseTres = this.botones[event].visto ? "visto" : "";
      return claseUno + " " + claseTres;
    }
  },
  computed: {
    botones() {
      var arrayBots = [];
      for (let index = 0; index < this.numeroBotones; index++) {
        arrayBots.push({
          visto: index==0?true:false
        });
      }
      return arrayBots;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/variables";
@import "../../sass/helpers/mixins";

.bots-num-bottom {
  overflow: hidden;
  width: 100%;
  max-width: 800px;
  margin: auto;
  .bnb-contain {
    min-height: 200px;
  }
  .bnb-buttons {
    display: inline-block;
    background-color: #DDD;
    padding: 5px;
    width: auto;
    min-width: 400px;
    border-radius: 50px;
    @include insetshadow(0 0 5px gray);
    li {
      display: inline-block;
    }
    button {
      background-color: #eee;
      color: #222;
      font-weight: bold;
      font-size: 1.4rem;
      min-width: 31px;
      min-height: 31px;
      margin: 5px;
      position: relative;
      @include shadow(0 0 5px #333);
      &.visto {
        &:after {
          content: "";
          background-image: url("../../assets/logos-icons/ok-bullet.png");
          background-size: contain;
          position: absolute;
          width: 20px;
          height: 20px;
          right: -10px;
          top: -10px;
        }
      }
      &.active {
        background-color: $primary-red;
        color: white;
      }
    }
  }
}
.textos {
  &:focus {
    outline: none;
  }
}
</style>




// WEBPACK FOOTER //
// BotsNumberBottom.vue?29d8e32a